const dashboard_messages = {
  asset_tasks_table_title: ['dashboard>>asset_tasks_table_title', 'My assets activities'],
};

export default dashboard_messages;
